<!-- MOLECULE: AllVisitsActions.vue -->

<script setup lang="ts">
//
// Imports
//

import AppBarActionButton from "./AppBarActionButton.vue";
import { useFqlFilters } from "@/composables/pages/all-visits/useFqlFilters";

//
// Composables
//

const { t } = useI18n();

// Read shared visits state — same key as useAllVisitsPage so we see the same data
const { loading, visits } = useVisits("all-visits");
const { filterCount, openFilterDialog } = useFqlFilters();

/**
 * Shared refresh trigger — useAllVisitsPage watches this useState counter.
 * Incrementing it here triggers a reload without instantiating the full
 * page composable (which would register duplicate watchers + onMounted).
 */
const refreshTrigger = useState<number>("all-visits.refreshTrigger", () => 0);

function triggerRefresh(): void {
  refreshTrigger.value++;
}

/** Total result count from the paginated response — shown on the badge when filters are active */
const resultCount = computed(
  () => (visits.value as { totalCount?: number } | null)?.totalCount ?? 0,
);
</script>

<template>
  <v-badge
    location="top right"
    color="error"
    offset-y="4"
    offset-x="4"
    :height="18"
    :content="String(resultCount)"
    :model-value="filterCount > 0"
  >
    <app-bar-action-button
      icon="mdi-filter-outline"
      :tooltip-text="t('pages.all-visits.actions.filter')"
      @click="openFilterDialog"
    />
  </v-badge>

  <app-bar-action-button
    icon="mdi-refresh"
    :tooltip-text="t('pages.all-visits.actions.refresh')"
    :loading="loading"
    :disabled="loading"
    @click="triggerRefresh"
  />
</template>
